(function () {
  var originRegistry = new Map();

  function getVariants(scope) {
    var script = scope.querySelector("[data-variant-json]");

    if (!script) {
      return null;
    }

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function variantFromSelect(select, scope) {
    if (!select) {
      return null;
    }

    var variants = getVariants(scope);
    var variantId = select.value;

    if (variants && variantId) {
      var match = variants.find(function (variant) {
        return String(variant.id) === String(variantId);
      });

      if (match) {
        return match;
      }
    }

    var option = select.options[select.selectedIndex];

    if (!option) {
      return null;
    }

    return {
      title: option.text.replace(/\s*-\s*[^\s]+$/, "").trim(),
    };
  }

  function setReactValue(input, value) {
    var setter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      "value"
    ).set;
    setter.call(input, value);
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function fillKlaviyoField(formRoot, labelText, value) {
    var labels = formRoot.querySelectorAll("label");

    for (var i = 0; i < labels.length; i++) {
      if (labels[i].textContent.trim().toLowerCase() === labelText.toLowerCase()) {
        var id = labels[i].getAttribute("for");
        var input = id ? formRoot.querySelector('[id="' + id + '"]') : null;

        if (input && input.value !== value) {
          setReactValue(input, value);
        }
        return;
      }
    }
  }

  function textOf(modal, selector) {
    var el = modal.querySelector(selector);
    return el ? el.textContent.trim() : "";
  }

  function enquiryProductUrl(modal) {
    return (
      modal.getAttribute("data-enquiry-product-url") ||
      textOf(modal, "[data-enquiry-product-url]")
    );
  }

  function fillKlaviyoFromModal(modal) {
    var formRoot = modal.querySelector('[class*="klaviyo-form-"]');

    if (!formRoot) {
      return;
    }

    fillKlaviyoField(formRoot, "Product", textOf(modal, "[data-enquiry-product-title]"));
    fillKlaviyoField(formRoot, "Variant", textOf(modal, "[data-enquiry-variant-title]"));
    fillKlaviyoField(formRoot, "Product URL", enquiryProductUrl(modal));
  }

  function scheduleFillKlaviyoFromModal(modal) {
    [0, 50, 300].forEach(function (delay) {
      window.setTimeout(function () {
        fillKlaviyoFromModal(modal);
      }, delay);
    });
  }

  function notifyEnquiryModalReady(modal) {
    document.dispatchEvent(
      new CustomEvent("enquiry-modal:ready", {
        detail: { modal: modal },
      })
    );
  }

  function getGlobalModal() {
    return document.querySelector("[data-modal]");
  }

  function releaseEnquireTrigger(trigger) {
    if (!trigger) {
      return;
    }

    trigger.classList.add("product-enquiry__trigger--engaged");
    trigger.blur();

    function clearEngaged() {
      trigger.classList.remove("product-enquiry__trigger--engaged");
      document.removeEventListener("mousemove", clearEngaged);
    }

    document.addEventListener("mousemove", clearEngaged, { once: true });
    window.setTimeout(clearEngaged, 600);
  }

  function resetEnquiryUi(modal) {
    if (!modal) {
      return;
    }

    var success = modal.querySelector("[data-enquiry-success]");
    var formWrap = modal.querySelector("[data-enquiry-form]");

    if (success) {
      success.hidden = true;
    }

    if (formWrap) {
      formWrap.removeAttribute("hidden");
    }

    delete modal.dataset.enquirySubmitted;
  }

  function showEnquirySuccess(modal) {
    if (!modal || modal.dataset.enquirySubmitted === "true") {
      return;
    }

    modal.dataset.enquirySubmitted = "true";

    var success = modal.querySelector("[data-enquiry-success]");
    var formWrap = modal.querySelector("[data-enquiry-form]");

    if (formWrap) {
      formWrap.hidden = true;
    }

    if (success) {
      success.hidden = false;
    }
  }

  function ensureBodyScrollRestored() {
    var modal = getGlobalModal();

    if (modal && modal.classList.contains("active")) {
      return;
    }

    document.body.setAttribute("data-fluorescent-overlay-open", "false");
    document.body.style.overflow = "";
  }

  function handleEnquiryClose() {
    restorePortal();
    document.querySelectorAll(".product-enquiry__trigger--engaged").forEach(function (trigger) {
      trigger.classList.remove("product-enquiry__trigger--engaged");
      trigger.blur();
    });
    window.setTimeout(ensureBodyScrollRestored, 350);
  }

  function updateEnquiryContext(variant) {
    document.querySelectorAll("[data-product-enquiry-modal]").forEach(function (modal) {
      var variantEl = modal.querySelector("[data-enquiry-variant-title]");
      var separatorEl = modal.querySelector("[data-enquiry-context-separator]");

      if (!variantEl) {
        return;
      }

      var variantTitle = variant && variant.title ? variant.title : "";

      if (variantTitle === "Default Title") {
        variantTitle = "";
      }

      variantEl.textContent = variantTitle;

      if (separatorEl) {
        if (variantTitle) {
          separatorEl.removeAttribute("hidden");
        } else {
          separatorEl.setAttribute("hidden", "");
        }
      }

      fillKlaviyoFromModal(modal);
    });
  }

  function rememberOrigin(modal) {
    if (!modal || !modal.id || originRegistry.has(modal.id)) {
      return;
    }

    originRegistry.set(modal.id, {
      parent: modal.parentNode,
      next: modal.nextSibling,
    });
  }

  function restoreToOrigin(modal) {
    if (!modal || modal.dataset.modalPortalActive !== "true") {
      return;
    }

    var origin = originRegistry.get(modal.id);

    if (!origin || !origin.parent || !origin.parent.isConnected) {
      return;
    }

    if (origin.next && origin.next.parentNode === origin.parent) {
      origin.parent.insertBefore(modal, origin.next);
    } else {
      origin.parent.appendChild(modal);
    }

    delete modal.dataset.modalPortalActive;
    delete modal.dataset.enquiryKlaviyoWatched;
  }

  function restoreAllPortals() {
    document
      .querySelectorAll('[data-product-enquiry-modal][data-modal-portal-active="true"]')
      .forEach(restoreToOrigin);
  }

  function markEnquirySources(root) {
    (root || document)
      .querySelectorAll("[data-product-enquiry-modal]")
      .forEach(function (modal) {
        if (!modal.closest("[data-modal] .modal__content")) {
          modal.dataset.enquirySource = "true";
          rememberOrigin(modal);
        }
      });
  }

  function getModalContent() {
    return document.querySelector("[data-modal] .modal__content");
  }

  function findEnquirySource(sourceId) {
    if (!sourceId) {
      return null;
    }

    return document.querySelector(
      '[data-product-enquiry-modal][data-enquiry-source="true"][id="' +
        sourceId.replace(/\\/g, "\\\\").replace(/"/g, '\\"') +
        '"]'
    );
  }

  function portalSwapIfNeeded() {
    var content = getModalContent();

    if (!content) {
      return null;
    }

    var inModal = content.querySelector("[data-product-enquiry-modal]");

    if (!inModal) {
      return null;
    }

    if (inModal.dataset.modalPortalActive === "true") {
      return inModal;
    }

    var original = findEnquirySource(inModal.id);

    if (!original || original === inModal) {
      return inModal;
    }

    rememberOrigin(original);
    inModal.remove();
    content.appendChild(original);
    original.dataset.modalPortalActive = "true";
    delete original.dataset.enquiryKlaviyoWatched;

    resetEnquiryUi(original);
    watchModals();
    scheduleFillKlaviyoFromModal(original);
    notifyEnquiryModalReady(original);

    return original;
  }

  function restorePortal() {
    restoreAllPortals();
  }

  function watchModals() {
    document.querySelectorAll("[data-product-enquiry-modal]").forEach(function (modal) {
      if (modal.dataset.enquiryKlaviyoWatched) {
        return;
      }
      modal.dataset.enquiryKlaviyoWatched = "true";

      var scheduled = false;
      var observer = new MutationObserver(function () {
        if (scheduled) {
          return;
        }
        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          fillKlaviyoFromModal(modal);
        });
      });

      observer.observe(modal, { childList: true, subtree: true });
      fillKlaviyoFromModal(modal);
    });
  }

  function watchGlobalModal() {
    var modal = document.querySelector("[data-modal]");
    var content = getModalContent();

    if (!modal || !content || modal.dataset.enquiryPortalWatched) {
      return;
    }

    modal.dataset.enquiryPortalWatched = "true";

    var contentObserver = new MutationObserver(function () {
      var swapped = portalSwapIfNeeded();

      if (swapped) {
        scheduleFillKlaviyoFromModal(swapped);
      }
    });

    contentObserver.observe(content, { childList: true });

    var modalObserver = new MutationObserver(function () {
      if (!modal.classList.contains("active")) {
        handleEnquiryClose();
      }
    });

    modalObserver.observe(modal, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  function initEnquiryContext(root) {
    var scope = root || document;
    var productRoot = scope.querySelector(".product") || scope;
    var select = productRoot.querySelector("[data-variant-select]");

    if (select && !select.dataset.enquiryBound) {
      select.dataset.enquiryBound = "true";
      select.addEventListener("change", function () {
        updateEnquiryContext(variantFromSelect(select, productRoot));
      });
      updateEnquiryContext(variantFromSelect(select, productRoot));
    }
  }

  document.addEventListener("product:variant-change", function (evt) {
    if (evt.detail && evt.detail.variant) {
      updateEnquiryContext(evt.detail.variant);
    }
  });

  document.addEventListener(
    "click",
    function (event) {
      if (event.target.closest("[data-modal-close]") || event.target.closest(".modal__wash")) {
        handleEnquiryClose();
        return;
      }

      var trigger = event.target.closest("[data-enquire-trigger]");

      if (!trigger) {
        return;
      }

      releaseEnquireTrigger(trigger);
      restorePortal();

      [50, 150, 400].forEach(function (delay) {
        window.setTimeout(function () {
          var modal = portalSwapIfNeeded();

          if (modal) {
            scheduleFillKlaviyoFromModal(modal);
          }
        }, delay);
      });
    },
    true
  );

  document.addEventListener("DOMContentLoaded", function () {
    markEnquirySources(document);
    initEnquiryContext(document);
    watchModals();
    watchGlobalModal();
  });

  document.addEventListener("shopify:section:load", function (evt) {
    markEnquirySources(evt.target);
    initEnquiryContext(evt.target);
    watchModals();
    watchGlobalModal();
  });

  window.addEventListener("klaviyoForms", function (event) {
    if (!event.detail) {
      return;
    }

    var modal = getModalContent() && getModalContent().querySelector("[data-product-enquiry-modal]");

    if (!modal) {
      return;
    }

    if (event.detail.type === "submit" || event.detail.type === "success") {
      window.setTimeout(function () {
        showEnquirySuccess(modal);
      }, 400);
    }
  });
})();
